var EGSettingsPivot = /* @__PURE__ */ ((EGSettingsPivot2) => {
  EGSettingsPivot2["general"] = "general";
  EGSettingsPivot2["extensions"] = "extensions";
  return EGSettingsPivot2;
})(EGSettingsPivot || {});
const CT_PATH_PREFIX = "/a";
const ROUTES = {
  sample: {
    root: {
      location: { pathname: "/sample" },
      match: { path: "/sample" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "/:pivot?" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    view: {
      location: { pathname: "/id" },
      match: { path: "/id/:entityId/:pivot?/:view?" }
    }
  },
  admin: {
    root: {
      location: {
        pathname: "/admin"
      },
      match: {
        path: "/admin"
      }
    },
    editSection: {
      location: { pathname: "" },
      match: {
        path: "/:section/:path*"
      }
    },
    config: {
      location: { pathname: "/config" },
      match: {
        path: "/config/:path*"
      }
    }
  },
  analysis: {
    root: {
      location: { pathname: "/analysis" },
      match: {
        path: "/analysis"
      }
    },
    list: {
      location: { pathname: "" },
      match: {
        path: "/:stepId"
      }
    },
    create: {
      location: { pathname: "" },
      match: {
        path: "/:stepId/create",
        params: {
          stepId: "stepId"
        }
      }
    },
    clone: {
      location: { pathname: "" },
      match: {
        path: "/:stepId/study/:studyId/clone",
        params: {
          stepId: "stepId",
          studyId: "studyId"
        }
      }
    },
    view: {
      location: { pathname: "" },
      match: {
        path: "/:stepId/(study)?/:studyId?/(task)?/:taskId?/:taskPivot?",
        params: {
          stepId: "stepId",
          studyId: "studyId",
          taskId: "taskId",
          taskPivot: "taskPivot",
          scorecardId: "scorecardId"
        }
      }
    },
    scorecardTask: {
      location: { pathname: "/scorecard-task" },
      match: {
        path: "/scorecard-task/:scorecardId",
        params: {
          scorecardId: "scorecardId"
        }
      }
    }
  },
  analysisConfig: {
    root: {
      location: { pathname: "/analysis-config" },
      match: { path: "/analysis-config" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    edit: {
      location: { pathname: "/edit" },
      match: {
        path: "/:configId/edit",
        params: {
          configId: "configId"
        }
      }
    }
  },
  analysisTemplate: {
    root: {
      location: { pathname: "/analysis-template" },
      match: {
        path: "/analysis-template/:editMode?/:templateName?"
      }
    },
    list: {
      location: { pathname: "" },
      match: {
        path: ""
      }
    },
    /**
     * Please note that analysis template uses editMode to define distinct views - e.g. view, create, create data-source
     * Do not reference this approach
     */
    create: {
      location: { pathname: "" },
      match: {
        path: "",
        params: {
          editMode: "editMode",
          templateName: "templateName"
        }
      }
    },
    view: {
      location: { pathname: "" },
      match: {
        path: "",
        params: {
          editMode: "editMode",
          templateName: "templateName"
        }
      }
    },
    dataSource: {
      location: { pathname: "" },
      match: {
        path: "",
        params: {
          editMode: "editMode",
          templateName: "templateName"
        }
      }
    }
  },
  experimentSearch: {
    root: {
      location: { pathname: "/a/search/experiments" },
      match: { path: "/search/experiments" }
    }
  },
  featureSearch: {
    root: {
      location: { pathname: "/feature-search" },
      match: { path: "/feature-search" }
    }
  },
  flightSearch: {
    root: {
      location: { pathname: "/a/search/flights" },
      match: { path: "/search/flights" }
    }
  },
  myactivitiesSearch: {
    root: {
      location: { pathname: "/a/search/myactivities" },
      match: { path: "/search/myactivities" }
    }
  },
  legacyBudgetSearch: {
    location: { pathname: "/Search/budget" },
    match: {
      path: "/Search/budget",
      params: { experimentId: "experimentId" }
    }
  },
  budgetSearch: {
    location: { pathname: "/a/search/budget" },
    match: {
      path: "/a/search/budget",
      params: { experimentId: "experimentId" }
    }
  },
  legacyanalysis: {
    location: { pathname: "/analysis/details" },
    match: {
      path: "/analysis/details",
      params: {
        stepId: "stepId",
        studyId: "studyId",
        taskId: "taskId",
        scorecardId: "scorecardId"
      }
    }
  },
  home: { match: { path: "/" }, location: { pathname: "/" } },
  searchExperiments: { match: { path: "/a/search/experiments" }, location: { pathname: "/a/search/experiments" } },
  experiment: {
    location: {
      pathname: "/a/experiment"
    },
    match: {
      path: "/a/experiment/:id/:pivot?/:view?",
      params: {
        id: "id",
        pivot: "pivot"
      }
    }
  },
  legacyAnalysisTemplate: {
    location: { pathname: "/analysis/template" },
    match: {
      path: "/analysis/template",
      params: {}
    }
  },
  myactivities: { match: { path: "/a/search/myactivities" }, location: { pathname: "/a/search/myactivities" } },
  help: { match: { path: "/a/help" }, location: { pathname: "/a/help" } },
  helpStudio: { match: { path: "/help" }, location: { pathname: "/help" } },
  details: {
    location: {
      pathname: "/details"
    },
    match: {
      path: "/details",
      params: {
        id: "id"
      }
    }
  },
  create: { location: { pathname: "/CreateExp/SelectTemplate" }, match: { path: "/CreateExp/SelectTemplate" } },
  selectTemplate: { location: { pathname: "/a/CreateExp/SelectTemplate" }, match: { path: "/a/CreateExp/SelectTemplate" } },
  /**
   * Flight
   */
  searchFlights: { match: { path: "/a/search/flights" }, location: { pathname: "/a/search/flights" } },
  legacyFlight: {
    location: {
      pathname: "/flight/detail"
    },
    match: {
      path: "/flight/detail",
      params: {
        id: "id",
        managementGroup: "managementGroup"
      }
    }
  },
  flightDetails: {
    location: {
      pathname: "/a/flight"
    },
    match: {
      path: "/a/flight/:id/:pivot?/:view?",
      params: {
        id: "id",
        pivot: "pivot",
        workspaceId: "workspaceId",
        managementGroup: "managementGroup"
      }
    }
  },
  legacyCreateFlight: { location: { pathname: "/Flight/Create" }, match: { path: "/Flight/Create" } },
  createFlight: {
    location: {
      pathname: "/a/flight/create"
    },
    match: {
      path: "/a/flight/create/:step?",
      params: {
        pivot: "step"
      }
    }
  },
  feature: {
    location: {
      pathname: "/a/feature"
    },
    match: {
      path: "/feature/:id?",
      params: {
        id: "id"
      }
    }
  },
  featureProgression: {
    root: {
      location: { pathname: "/feature" },
      match: { path: "/feature" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    view: {
      location: { pathname: "" },
      match: {
        path: "/:id?",
        params: {
          id: "id"
        }
      }
    }
  },
  featureRollout: {
    root: {
      location: { pathname: "/features" },
      match: { path: "/features" }
    },
    view: {
      location: { pathname: "" },
      match: {
        path: ":featureId/:pivot?",
        params: {
          featureId: "featureId",
          pivot: "pivot"
        }
      }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "create" }
    },
    edit: {
      location: { pathname: "/edit" },
      match: {
        path: "edit",
        params: {
          featureId: "featureId"
        }
      }
    },
    progressionView: {
      location: { pathname: "/progressions" },
      match: {
        path: "progressions/:progressionId",
        params: {
          featureId: "featureId",
          progressionId: "progressionId"
        }
      }
    },
    progressionCreate: {
      location: { pathname: "/progressions/create" },
      match: {
        path: "progressions/create",
        params: {
          featureId: "featureId"
        }
      }
    },
    experimentView: {
      location: { pathname: "/experiments" },
      match: {
        path: "experiments/:experimentId/:pivot?",
        params: {
          featureId: "featureId",
          experimentId: "experimentId",
          pivot: "pivot"
        }
      }
    },
    experimentCreate: {
      location: { pathname: "/experiments/create" },
      match: {
        path: "experiments/create",
        params: {
          featureId: "featureId"
        }
      }
    },
    compositionEdit: {
      location: { pathname: "/composition" },
      match: {
        path: "variants/:variantId/composition",
        params: {
          featureId: "featureId",
          variantId: "variantId"
        }
      }
    },
    analysisStudyGroupCreate: {
      location: { pathname: "/analyses/create" },
      match: {
        path: "analyses/create",
        params: {
          featureId: "featureId"
        }
      }
    }
  },
  variant: {
    redirect: {
      location: { pathname: "/variant" },
      match: {
        path: "/variant/:variantId",
        params: {
          variantId: "variantId"
        }
      }
    }
  },
  srmDebug: {
    location: {
      pathname: "/a/srm-debug"
    },
    match: {
      path: "/a/srm-debug/:id/:pivot?",
      params: {
        id: "id",
        pivot: "pivot"
      }
    }
  },
  extensions: {
    root: {
      location: { pathname: "/extension" },
      match: { path: "/extension" }
    },
    catapult: {
      location: { pathname: "/extension/catapult" },
      match: { path: "/extension/catapult" }
    },
    notebooks: {
      location: { pathname: "/extension/notebooks" },
      match: { path: "/extension/notebooks" }
    },
    arena: {
      location: { pathname: "/extension/arena" },
      match: { path: "/extension/arena" }
    },
    titan: {
      location: { pathname: "/extension/titan" },
      match: { path: "/extension/titan" }
    },
    edge: {
      location: { pathname: "/extension/edge" },
      match: { path: "/extension/edge" }
    },
    titanv2: {
      location: { pathname: "/extension/titanv2" },
      match: { path: "/extension/titanv2" }
    },
    native: {
      location: { pathname: "/extension/native" },
      match: { path: "/extension/native" }
    }
  },
  gar: {
    root: {
      location: { pathname: "/a/feature" },
      match: {
        path: "/a/feature/:id/analysis-results/:stepId/:pivot?/:panel?/(study)?/:studyId?/(task)?/:taskId?/:taskPivot?",
        params: {
          stepId: "stepId",
          pivot: "pivot",
          id: "id",
          studyId: "studyId",
          panel: "panel",
          taskId: "taskId",
          taskPivot: "taskPivot"
        }
      }
    },
    list: {
      location: { pathname: "/scorecards" },
      match: {
        path: "/:stepId"
      }
    },
    view: {
      location: { pathname: "/scorecards" },
      match: {
        path: "/a/feature/:id/analysis-results/:stepId/scorecards/(study)?/:studyId?/(task)?/:taskId?/:taskPivot?",
        params: {
          stepId: "stepId",
          studyId: "studyId",
          taskId: "taskId",
          taskPivot: "taskPivot"
        }
      }
    },
    create: {
      location: { pathname: "/scorecards/create" },
      match: {
        path: "/a/feature/:id/analysis-results/:stepId/scorecards/create",
        params: {
          stepId: "stepId"
        }
      }
    },
    clone: {
      location: { pathname: "/scorecards/study" },
      match: {
        path: "/a/feature/:id/analysis-results/:stepId/scorecards/(study)?/:studyId/clone",
        params: {
          stepId: "stepId",
          studyId: "studyId"
        }
      }
    },
    scorecardTask: {
      location: { pathname: "/scorecard-task" },
      match: {
        path: "/a/feature/:id/analysis-results/scorecard-task/:scorecardId",
        params: {
          scorecardId: "scorecardId"
        }
      }
    }
  },
  createExp: {
    location: { pathname: "/a/experiment/create" },
    match: { path: "/a/experiment/create", params: { wizardType: "wizardType", managementGroup: "managementGroup" } }
  },
  legacyCreateExp: {
    location: { pathname: "/CreateExp/Wizard" },
    match: { path: "/CreateExp/Wizard", params: { wizardType: "wizardType", managementGroup: "managementGroup" } }
  },
  dataSourceManagement: {
    root: {
      location: { pathname: "/datasource" },
      match: { path: "/datasource" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    view: {
      location: { pathname: "" },
      match: { path: "/:dataSourceName/:PivotItem?/:view?" }
    },
    overrideview: {
      location: { pathname: "" },
      match: { path: "/:dataSourceName/:dataSourceType/override/:dataSourceOverrideName/:PivotItem?/:view?" }
    },
    overridecreate: {
      location: { pathname: "" },
      match: { path: "/:dataSourceName/:dataSourceType/override/create/:fromVersion" }
    }
  },
  workspaceSettings: {
    root: {
      location: { pathname: "/workspace-settings" },
      match: { path: "/workspace-settings" }
    },
    view: {
      location: { pathname: "" },
      match: { path: "/:pivotItem?" }
    },
    credentialView: {
      location: { pathname: "/microsoft-credentials" },
      match: { path: "/microsoft-credentials/:navItem?" }
    },
    subscribersCreate: {
      location: { pathname: "/default-subscribers/create" },
      match: { path: "/default-subscribers/create" }
    },
    subscribersView: {
      location: { pathname: "/default-subscribers" },
      match: { path: "/default-subscribers/name/:entityName?" }
    },
    systemHealthBannerCreate: {
      location: { pathname: "/system-health-banners/create" },
      match: { path: "/system-health-banners/create" }
    },
    systemHealthBannerView: {
      location: { pathname: "/system-health-banners" },
      match: { path: "/system-health-banners/:entityName?" }
    }
  },
  egSettings: {
    root: {
      location: { pathname: "/eg-settings" },
      match: { path: "/eg-settings" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "/:pivotItem?" }
    },
    viewEGSetting: {
      location: { pathname: `/${"general"}` },
      match: { path: `/${"general"}/:settingId` }
    },
    createEGSetting: {
      location: { pathname: `/${"general"}/create` },
      match: { path: `/${"general"}/create` }
    },
    viewExtension: {
      location: { pathname: `/${"extensions"}` },
      match: { path: `/${"extensions"}/:extensionId` }
    },
    createExtension: {
      location: { pathname: `/${"extensions"}/create` },
      match: { path: `/${"extensions"}/create` }
    }
  },
  computeManagementSystem: {
    root: {
      location: { pathname: "/compute" },
      match: { path: "/compute" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    view: {
      location: { pathname: "" },
      match: { path: "/:entityId/:pivotItem?" }
    }
  },
  onboarding: {
    location: { pathname: "/onboarding" },
    match: { path: "/onboarding" }
  },
  onboardingHelp: {
    location: { pathname: "/onboarding/help" },
    match: { path: "/onboarding/help" }
  },
  tenant: {
    location: { pathname: "/tenant/choose" },
    match: { path: "/tenant/choose", params: { workspaceId: "workspaceId" } }
  },
  emergencyShutdown: {
    location: { pathname: "/a/emergency-shutdown" },
    match: {
      path: "/a/emergency-shutdown",
      params: {
        workspaceId: "workspaceId",
        managementGroup: "managementGroup",
        flightId: "flightId",
        experimentId: "experimentId"
      }
    }
  },
  legacyEmergencyShutdown: {
    location: { pathname: "/flight/emergencyshutdown" },
    match: {
      path: "/flight/emergencyshutdown",
      params: {
        workspaceId: "workspaceId",
        managementGroup: "managementGroup",
        flightId: "flightId",
        experimentId: "experimentId"
      }
    }
  },
  legacyRollout: {
    location: {
      pathname: "/rollout"
    },
    match: {
      path: "/rollout",
      params: {
        id: "id"
      }
    }
  },
  legacyResolveGate: {
    location: { pathname: "/Gate/ResolveGate" },
    match: {
      path: "/Gate/ResolveGate",
      params: {
        gateName: "gateName",
        target: "target",
        justificationNeeded: "justificationNeeded"
      }
    }
  },
  resolveGate: {
    location: { pathname: "/a/gate/resolve" },
    match: {
      path: "/a/gate/resolve",
      params: {
        gateName: "gateName",
        target: "target",
        justificationNeeded: "justificationNeeded"
      }
    }
  },
  legacyResolveSeedfinderGate: {
    location: { pathname: "/details/ResolveSeedFinderGate" },
    match: {
      path: "/details/ResolveSeedFinderGate",
      params: {
        stepId: "stepId"
      }
    }
  },
  resolveSeedfinderGate: {
    location: { pathname: "/a/gate/resolve-seedfinder" },
    match: {
      path: "/a/gate/resolve-seedfinder",
      params: {
        stepId: "stepId"
      }
    }
  },
  legacyResolveAutoRampUpGate: {
    location: { pathname: "/details/ResolveAutoRampUpGate" },
    match: {
      path: "/details/ResolveAutoRampUpGate",
      params: {
        stepId: "stepId"
      }
    }
  },
  resolveAutoRampUpGate: {
    location: { pathname: "/a/gate/resolve-auto-ramp-up" },
    match: {
      path: "/a/gate/resolve-auto-ramp-up",
      params: {
        stepId: "stepId"
      }
    }
  },
  helpTicket: { match: { path: "/help/ticket" }, location: { pathname: "/help/ticket" } },
  /**
   * STUDIO ROUTES
   */
  studio: {
    location: {
      pathname: "/workspaces"
    },
    match: {
      path: "/workspaces/:workspaceId?",
      params: {
        workspaceId: "workspaceId"
      }
    }
  },
  studioWelcome: {
    location: {
      pathname: "/workspaces"
    },
    match: {
      path: "/workspaces/:workspaceId/:pivot?",
      params: {
        workspaceId: "workspaceId",
        pivot: "pivot"
      }
    }
  },
  featureExperiment: {
    root: {
      location: { pathname: "/feature-experiment" },
      match: { path: "/feature-experiment" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    view: {
      location: { pathname: "" },
      match: {
        path: "/:featureId/:pivot?",
        params: {
          featureId: "featureId",
          pivot: "pivot"
        }
      }
    },
    audienceStageCreate: {
      location: { pathname: "/audience-stage/create" },
      match: {
        path: "/:featureId/audience-stage/create",
        params: {
          featureId: "featureId"
        }
      }
    },
    audienceStageView: {
      location: { pathname: "/audience-stage" },
      match: {
        path: "/:featureId/audience-stage/:audienceStageId/:pivot?/:view?",
        params: {
          featureId: "featureId",
          audienceStageId: "audienceStageId",
          pivotKey: "pivotKey"
        }
      }
    }
  },
  workspaceSelector: {
    location: {
      pathname: "/workspace-selector"
    },
    match: {
      path: "/workspace-selector",
      params: {}
    }
  },
  /**
   * Audience Filters
   */
  audienceFilter: {
    root: {
      location: {
        pathname: "/audience-filters"
      },
      match: {
        path: "/audience-filters"
      }
    },
    create: {
      location: {
        pathname: "/create"
      },
      match: {
        path: "create"
      }
    },
    list: {
      location: {
        pathname: ""
      },
      match: {
        path: ""
      }
    },
    view: {
      location: {
        pathname: ""
      },
      match: {
        path: ":audiencefilters"
      }
    }
  },
  /**
   * TODO unified studio
   * consolidate feature / progression URLs
   * Progressions Route
   */
  progressions: {
    location: { pathname: "/a/feature" },
    match: {
      path: "/a/feature/:id?",
      params: {
        id: "id"
      }
    }
  },
  assignmentUnit: {
    root: {
      location: { pathname: "/assignment-unit" },
      match: { path: "/assignment-unit" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "" }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "create" }
    },
    view: {
      location: { pathname: "" },
      match: { path: ":assignmentUnitId" }
    }
  },
  isolationGroup: {
    root: {
      location: { pathname: "/isolation-group" },
      match: { path: "/isolation-group" }
    },
    list: {
      location: { pathname: "" },
      match: {
        path: ""
      }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "create" }
    },
    view: {
      location: { pathname: "" },
      match: { path: ":isolationGroupId" }
    }
  },
  /**
   * MAUI
   */
  metricsAuthoring: {
    opt_in_root: {
      location: { pathname: "/metrics-authoring-opt-in" },
      match: { path: "/metrics-authoring-opt-in" }
    },
    root: {
      location: { pathname: "/metric-set" },
      match: { path: "/metric-set" }
    },
    list: {
      location: { pathname: "" },
      match: { path: "/:metricSetName?/:hasDraft(draft)?/:draftName?/:entityName?/:subEntityName?/:mode?" }
    },
    viewDrafts: {
      location: { pathname: "" },
      match: { path: "/:metricSetName" }
    },
    createMetricSet: {
      location: { pathname: "/create" },
      match: { path: "/create" }
    },
    cloneMetricSet: {
      location: { pathname: "/clone" },
      match: { path: "/clone" }
    },
    createDraft: {
      location: { pathname: "" },
      match: { path: "/:metricSetName/draft/:create(create)" }
    },
    viewMetricSet: {
      location: { pathname: "" },
      match: { path: "/:metricSetName/:hasDraft(draft)/:draftName" }
    },
    setup: {
      location: { pathname: "" },
      match: { path: "/:metricSetName/:hasDraft(draft)/:draftName/setup/:setting?" }
    },
    configuration: {
      location: { pathname: "" },
      match: { path: "/:metricSetName/:hasDraft(draft)/:draftName/configuration/:setting?" }
    }
  },
  scorecard: {
    root: {
      location: { pathname: "/scorecard" },
      match: { path: "/scorecard" }
    }
  },
  /**
   * Progression Templates
   */
  progressionTemplates: {
    root: {
      location: { pathname: "/progression-templates" },
      match: { path: "/progression-templates" }
    },
    list: {
      location: { pathname: "" },
      match: {
        path: ""
      }
    },
    create: {
      location: { pathname: "/create" },
      match: { path: "create" }
    },
    view: {
      location: { pathname: "" },
      match: { path: ":progressionTemplateId" }
    }
  }
};
export {
  CT_PATH_PREFIX,
  EGSettingsPivot,
  ROUTES
};
//# sourceMappingURL=Routes.constants.js.map
